import LoginPage from '@/components/auth/LoginPage.vue';
import RegisterPage from '@/components/auth/RegisterPage.vue';
import EmailConfirmation from '@/components/auth/EmailConfirmation.vue';
import ForgotPassword from '@/components/auth/ForgotPassword.vue';
import ResetPassword from '@/components/auth/ResetPassword.vue';
import ResendConfirmation from '@/components/auth/ResendConfirmation.vue';

const authRoutes = [{
    path: '/login',
    component: LoginPage,
    meta: {
        title: "Login | Akademi Siber"
    },
},
{
    path: '/register',
    component: RegisterPage,
    meta: {
        title: "Register | Akademi Siber"
    },
},
{
    path: '/confirm-email/:token',
    component: EmailConfirmation,
    meta: {
        title: "Email Confirmation | Akademi Siber"
    },
},
{
    path: '/forgot-password',
    component: ForgotPassword,
    meta: {
        title: "Forgot Password | Akademi Siber"
    },
},
{
    path: '/reset-password/:token',
    component: ResetPassword,
    meta: {
        title: "Reset Password | Akademi Siber"
    },
},
{
    path: '/resend-confirmation',
    component: ResendConfirmation,
    meta: {
        title: "Resend Confirmation | Akademi Siber"
    },
}
];

export default authRoutes;